<template>
  <portal>
      <div class="mb-8 d-flex align-center">
          <v-icon color="primary" size="30">mdi-chart-pie</v-icon>
          <h1 class="headline ml-4 font-weight-bold grey--text--darken-2 text-uppercase">Positions</h1>
      </div>

      <year-to-date-positions v-if="positions !== null" />
      <template v-slot:disclosure>
          <v-col class="px-12 py-8" v-html="company.disclosure_client_portal"></v-col>
      </template>
  </portal>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import Portal from "@/components/Portal";
import YearToDatePositions from "@/components/year-to-date/YearToDatePositions";

export default {
    name: "Positions",
    components: {
      YearToDatePositions,
      Portal,
    },
    computed: {
        ...mapGetters('auth', [
            'user',
        ]),
        ...mapState({
            positions: state => state.household.positions,
        }),
        ...mapState('company', [
            'company'
        ])
    },
    data() {
        return {
            ytdIsLoading: false,
            positionsIsLoading: false,
            fsIsLoading: false,
        }
    },
    created() {
        this.$store.dispatch('household/fetchPositions', this.user.household_id);
    },
    mounted() {
      if (! this.user.has_external_household) {
            this.$router.push({ name: 'GetStarted' });
            return;

      }

      let vm = this;
      window.Echo.channel('client.report.positions.' + this.user.household_id)
          .listen('.Household\\Events\\ClientReportCompleteEvent', (e) => {
            vm.$store.commit('household/setPositions', e);
              this.$store.dispatch('loader/done');
          });
    }
  }
</script>
